export const selectIsAuth = state => state.auth.isAuth;
export const selectToken = state => state.auth.token;
export const selectUser = state => state.auth.user;
export const selectRefresh = state => state.auth.isRefresher;
